import { boltApi } from 'store/queries/bolt-api'
import { GetProductsResponse } from './types.ts'
import { Flow } from 'types/logging.ts'
import { createErrorTransformer } from 'store/queries/utils.ts'

export const productsBoltApi = boltApi.injectEndpoints({
  endpoints: (builder) => ({
    // GET PRODUCTS
    getProducts: builder.query<GetProductsResponse, void>({
      query: () => ({
        method: 'GET',
        url: '/products'
      }),
      transformResponse: ({ data }) => {
        return data
      },
      transformErrorResponse: createErrorTransformer(`[${Flow.PRODUCTS}:getProducts]`)
    })
  })
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetProductsQuery, useLazyGetProductsQuery } = productsBoltApi
